import { Tag, Team, User, UserStatus } from "../types/user";
import { CheckCircleIcon, ExclamationCircleIcon, InformationCircleIcon, QuestionMarkCircleIcon } from "@heroicons/react/24/solid";

export enum AlertType {
    Success = 'success',
    Info = 'info',
    Error = 'error',
}

export const getAlertIconColor = (type: AlertType): string => {
    switch (type) {
        case AlertType.Success:
            return 'text-green-600';
        case AlertType.Info:
            return 'text-blue-600';
        case AlertType.Error:
            return 'text-red-600';
        default:
            return 'text-gray-600';
    }
}

export const getAlertBackgroundColor = (type: AlertType): string => {
    switch (type) {
        case AlertType.Success:
            return 'bg-green-600';
        case AlertType.Info:
            return 'bg-blue-600';
        case AlertType.Error:
            return 'bg-red-600';
        default:
            return 'bg-gray-600';
    }
}

export const getAlertIcon = (type: AlertType): React.ElementType => {
    switch (type) {
        case AlertType.Success:
            return CheckCircleIcon;
        case AlertType.Info:
            return InformationCircleIcon;
        case AlertType.Error:
            return ExclamationCircleIcon;
        default:
            return QuestionMarkCircleIcon;
    }
}

// Function to get user status for display
export const getUserStatusDisplay = (status: UserStatus): { label: string; color: string } => {
    switch (status) {
      case UserStatus.Active:
        return { label: 'Active', color: 'green' };
      case UserStatus.Invited:
        return { label: 'Invited', color: 'blue' };
      default:
        return { label: 'Unknown', color: 'gray' };
    }
  };

// Function to generate CSV from users
export const generateCSV = (users: User[], tags:Tag[], teams:Team[]) => {
    const csvRows: string[] = [];

    // Add header row
    csvRows.push('Name,Email,Teams,Tags,Status,Role');

    // Add data rows
    users.forEach(user => {
        const csvRow = [
            user.name,
            user.email,
            user.teams.map(team => {
                const foundTeam = teams.find(t => t.id === team);
                return foundTeam ? foundTeam.name : team;
            }).join('; '),
            user.tags.map(tag => {
                const foundTag = tags.find(t => t.id === tag);
                return foundTag ? foundTag.name : tag;
            }).join('; '),
            user.status,
            user.role.replace("org:", "").replace(/_/g, ' ')
        ].map(value => `"${value.replace(/"/g, '""')}"`).join(',');  
        csvRows.push(csvRow);
    });

    return csvRows.join('\n');
}

export const downloadCSV = (csv: string, filename: string) => {
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
}